import { Box } from "@mui/material";
import * as firebase from "firebase/app";
import "firebase/messaging";
import { getMessaging, onMessage } from "firebase/messaging";
import { useRouter } from "next/router";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";

import { NotificationType } from "../constants/Notification";
import useSendMessage from "../customHooks/useSendMessage";
import { firebaseCloudMessaging } from "../firebase/firebase";
import { NotificationData } from "../interfaces/Notification";
import {
  setMessageBadge,
  setNotificationBadge,
  setNotificationTab,
} from "../redux/messagingSlice";

function PushNotificationLayout({ children }: { children: JSX.Element }) {
  const { handleSendMessage } = useSendMessage();
  const router = useRouter();
  const dispatch = useDispatch();
  useEffect(() => {
    setToken();

    // Event listener that listens for the push notification event in the background
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        // Do Something
      });
    }

    // Calls the getMessage() function if the token is there
    async function setToken() {
      try {
        const token = await firebaseCloudMessaging.tokenInLocalStorage();
        if (token) {
          getMessage();
        }
      } catch (error) {
        console.log(error);
      }
    }
  });

  const handleShowNotificationTab = () => {
    dispatch(setNotificationTab(0));
    router.push("/message");
  };

  const handleGetNotification = (data: NotificationData) => {
    switch (data.type) {
      // case NotificationType.MESSAGING:
      //   dispatch(setMessageBadge(false));
      //   break;
      case NotificationType.NOTIFICATION:
        dispatch(setNotificationBadge(false));
        break;
      default:
        break;
    }
  };

  // Handles the click function on the toast showing push notification
  const handleClickPushNotification = (data: NotificationData) => {
    switch (data.type) {
      // case NotificationType.MESSAGING:
      //   handleSendMessage(data.senderId, data.receiverId);
      //   break;

      case NotificationType.NOTIFICATION:
        handleShowNotificationTab();
        break;

      default:
        break;
    }
  };

  // Get the push notification message and triggers a toast to display it
  function getMessage() {
    const messaging = getMessaging();
    onMessage(messaging, (payload) => {
      if (payload?.data?.type === NotificationType.MESSAGING) {
        return;
      }
      handleGetNotification(payload.data as unknown as NotificationData);
      return toast(
        <Box
          sx={{ cursor: "pointer" }}
          onClick={() =>
            payload.data &&
            handleClickPushNotification(
              payload.data as unknown as NotificationData
            )
          }
        >
          <h5>{payload?.notification?.title}</h5>
          <h6>{payload?.notification?.body}</h6>
        </Box>,
        {
          closeOnClick: false,
        }
      );
    });
  }

  return (
    <>
      <ToastContainer />
      {children}
    </>
  );
}

export default PushNotificationLayout;
